import { initializeLocalization } from 'owa-localize';
import { initializeOwaTimeFormatTranslations } from 'owa-timeformat-localization';
import { initializeOwaDateTimeTranslations } from 'owa-datetime-localization';

// TODO: Clean this up once we're fully on the new startup flow (51567)
export function initializeOwaLocalization(
    culture: string,
    bootStrings: Record<string, string>
): Promise<void> {
    /**
     * Any shared packages that are used in boot should have their
     * localization initialized here. Any shared packages *not* used in boot
     * should have their localization initialized by the LazyModule which loads
     * the shared package
     */
    initializeOwaTimeFormatTranslations();
    initializeOwaDateTimeTranslations();
    return initializeLocalization(culture, bootStrings);
}
